"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonTabs = require("@mmc/common-tabs");
var _text = require("@mmc/text");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _productLinks = _interopRequireDefault(require("./product-links"));
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray;
var clickHandler = function clickHandler(event, name) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'navclick',
      component: 'top_nav',
      action: "tab_click",
      section_name: name,
      click_text: event.target.innerText
    });
  }
};
var ProductTabs = function ProductTabs(_ref) {
  var products = _ref.products,
    theme = _ref.theme,
    name = _ref.name,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    market = _ref.market,
    config = _ref.config,
    currentPath = _ref.currentPath,
    keyHandlerMethod = _ref.keyHandlerMethod,
    mobileNavActive = _ref.mobileNavActive,
    hideArrows = _ref.hideArrows;
  var tabNames = !isEmptyArray(products) ? products.map(function (item) {
    return item.vehiclesHeader;
  }) : [];
  var totalSetSize = 10;
  return /*#__PURE__*/_react["default"].createElement(_commonTabs.CommonTabs, {
    tabNames: tabNames,
    variant: "light",
    tabListClasses: _navigationHeader["default"].tabList
    // disclaimerData={disclaimerData}
    ,
    onTabChange: function onTabChange() {
      return clickHandler(event, name);
    }
  }, !isEmptyArray(products) && products.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "products"
    }, /*#__PURE__*/_react["default"].createElement(_productLinks["default"], {
      products: item.vehicles,
      theme: theme,
      totalSetSize: totalSetSize,
      name: name,
      sectionName: item.vehiclesHeader,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      market: market,
      config: config,
      currentPath: currentPath,
      keyHandlerMethod: keyHandlerMethod,
      mobileNavActive: mobileNavActive,
      hideArrows: hideArrows
    }));
  }));
};
ProductTabs.displayName = 'ProductTabs';
var _default = ProductTabs;
exports["default"] = _default;